import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { CognitiveSearchPanel } from "../components/CognitiveSearchPanel";
import { HowItWorks } from "../components/HowItWorks";
import { ResultsPreview } from "../components/ResultsPreview";
import { KnowledgeGraphSection } from "../components/KnowledgeGraphSection";
import { Technology } from "../components/Technology";
import { BrandFamily } from "../components/BrandFamily";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="relative bg-[#0A1A2F]">
      <Navbar />
      <main>
        <Hero />
        <CognitiveSearchPanel />
        <HowItWorks />
        <ResultsPreview />
        <KnowledgeGraphSection />
        <Technology />
        <BrandFamily />
      </main>
      <Footer />
    </div>
  );
}
